export const scrollToElement = (itemId: string, delay: number = 200): void => {
  setTimeout(() => {
    const element = document.getElementById(itemId);
    if (element) {
      if (typeof element.scrollIntoView === 'function') {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
      }
      if (typeof element.focus === 'function') {
        element.focus();
      }
    }
  }, delay);
};
